<!-- eslint-disable-next-line vue/multi-word-component-names -->
<!-- Contact Page -->
<template>
  <page-layout header="Contact">
    <divider />
    <h5>If you would like to contact Polly, please fill out the form below.</h5>
    <form @submit.prevent="submitForm" class="form">
      <div class="form-row">
        <div class="form-group">
          <label for="email">Email Address:</label>
          <input type="email" id="email" v-model="email" required />
        </div>
        <div class="form-group">
          <label for="subject">Subject:</label>
          <input type="text" id="subject" v-model="subject" required />
        </div>
      </div>
      <div class="form-group full-width">
        <label for="body">Email Body:</label>
        <textarea id="body" v-model="body" required />
      </div>
      <Button type="submit" label="Send" />
    </form>
  </page-layout>
</template>

<script>
// import components
import PageLayout from "./global-styles/layout/PageLayout.vue";
import Divider from "./global-styles/default/Divider.vue";
import Button from "./global-styles/components/Button.vue";
import { sendContactEmail } from "../services/contactService";

export default {
  name: "ContactPage",
  components: {
    PageLayout,
    Divider,
    Button,
  },
  data() {
    return {
      email: "",
      subject: "",
      body: "",
    };
  },
  methods: {
    async submitForm() {
      try {
        debugger;
        const response = sendContactEmail({
          email: this.email,
          subject: this.subject,
          body: this.body,
        });
        alert(response.message || "Email sent.");
      } catch (error) {
        console.error("Error sending email:", error);
        alert("An error occurred. Please try again later.");
      }
    },
  },
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
.form-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 1em;
}
.form-group {
  flex: 1; /* Allows equal width for email and subject fields */
  display: flex;
  flex-direction: column;
  font-family: "PT Serif", serif;
  margin-bottom: 1em;
}
.form-group.full-width {
  width: 100%; /* Ensures the textarea spans full width */
}
.form-group textarea {
  height: 200px;
  box-sizing: border-box;
  resize: none; /* Disables the resize handle */
}

/* Large tablets and small desktops */
@media (max-width: 1024px) {
  .form {
    max-width: 700px;
  }
}

/* Tablets */
@media (max-width: 768px) {
  .form {
    padding: 0 1em;
    max-width: 600px;
  }
  .form-row {
    flex-direction: column;
    gap: 0.5em;
  }
  .form-group {
    width: 100%;
  }
  .form-group input,
  .form-group textarea {
    padding: 0.65em;
  }
  .form-group textarea {
    height: 180px;
  }
}

/* Small tablets and large mobile */
@media (max-width: 640px) {
  .form {
    padding: 0 0.5em;
    max-width: 500px;
  }
  .form-group input,
  .form-group textarea {
    font-size: 0.95em;
    padding: 0.6em;
  }
  .form-group textarea {
    height: 160px;
  }
}

/* Large mobile phones */
@media (max-width: 480px) {
  .form {
    padding: 0 0.3em;
    max-width: 450px;
  }
  .form-group {
    margin-bottom: 0.8em;
  }
  .form-group input,
  .form-group textarea {
    font-size: 0.9em;
    padding: 0.55em;
  }
  .form-group textarea {
    height: 150px;
  }
}

/* Standard mobile phones */
@media (max-width: 375px) {
  .form {
    padding: 0 0.2em;
    max-width: 400px;
  }
  .form-group {
    margin-bottom: 0.7em;
  }
  .form-group input,
  .form-group textarea {
    font-size: 0.85em;
    padding: 0.5em;
  }
  .form-group textarea {
    height: 140px;
  }
}

/* Medium mobile phones */
@media (max-width: 360px) {
  .form {
    padding: 0 0.1em;
    max-width: 350px;
  }
  .form-group {
    margin-bottom: 0.65em;
  }
  .form-group input,
  .form-group textarea {
    font-size: 0.8em;
    padding: 0.45em;
  }
  .form-group textarea {
    height: 130px;
  }
}

/* Extra small mobile phones */
@media (max-width: 320px) {
  .form {
    padding: 0;
    max-width: 300px;
  }
  .form-group {
    margin-bottom: 0.6em;
  }
  .form-group input,
  .form-group textarea {
    font-size: 0.75em;
    padding: 0.4em;
  }
  .form-group textarea {
    height: 120px;
  }
}
</style>
